import React from 'react';
import Icon from '../../../components/AppIcon';

const TopProductsTable = ({ products }) => {
  if (!products || products?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Top Selling Products</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="Package" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No product sales data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Top Selling Products</h2>
        <Icon name="TrendingUp" size={20} className="text-primary" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">#</th>
              <th className="text-left py-3 px-2 text-sm font-medium text-muted-foreground">Product</th>
              <th className="text-right py-3 px-2 text-sm font-medium text-muted-foreground">Qty Sold</th>
              <th className="text-right py-3 px-2 text-sm font-medium text-muted-foreground">Revenue</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => (
              <tr key={product?.product_id} className="border-b border-border hover:bg-accent/50 transition-colors">
                <td className="py-3 px-2 text-sm text-foreground font-medium">{index + 1}</td>
                <td className="py-3 px-2">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="Package" size={16} className="text-primary" />
                    </div>
                    <span className="text-sm font-medium text-foreground">{product?.product_name}</span>
                  </div>
                </td>
                <td className="py-3 px-2 text-right text-sm text-foreground">{product?.quantity_sold}</td>
                <td className="py-3 px-2 text-right text-sm font-semibold text-success">
                  ${product?.revenue?.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopProductsTable;